/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The HTTP verbs that are used in the UI-API
 * @export
 */
export const HttpVerbConstants = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE'
} as const;
export type HttpVerbConstants = typeof HttpVerbConstants[keyof typeof HttpVerbConstants];


export function HttpVerbConstantsFromJSON(json: any): HttpVerbConstants {
    return HttpVerbConstantsFromJSONTyped(json, false);
}

export function HttpVerbConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): HttpVerbConstants {
    return json as HttpVerbConstants;
}

export function HttpVerbConstantsToJSON(value?: HttpVerbConstants | null): any {
    return value as any;
}

